import { FirebaseAnalyticsService } from './firebaseAnalyticsService';
import { AmplitudeAnalyticsService } from './amplitudeAnalyticsService';
import { BaseAnalyticsService } from './baseAnalyticsService';

export * from './firebaseAnalyticsService';
export * from './baseAnalyticsService';
export * from './amplitudeAnalyticsService';
export * from './analyticsEvent';

export enum AnalyticsProvider {
  Firebase = 'firebase',
  Amplitude = 'amplitude',
}

export const analyticsServices: Record<
  AnalyticsProvider,
  typeof BaseAnalyticsService
> = {
  [AnalyticsProvider.Firebase]: FirebaseAnalyticsService,
  [AnalyticsProvider.Amplitude]: AmplitudeAnalyticsService,
};

export const getAnalyticsService = (providers: AnalyticsProvider[]) => {
  return providers.map((provider) => new analyticsServices[provider]());
};
